import { useAuth } from '@shared/components/AuthProvider';
import { useSignIn } from './useSignIn';

export const useChangeAccount = () => {
  const { loginManager } = useAuth();
  const { signIn } = useSignIn();

  const changeAccount = async () => {
    // Log user out
    await loginManager.authService.clearToken();
    // Take user to login screen. with a redirect back to the current page after completion.
    await signIn();
  };

  return { changeAccount };
};
